<template>
    <div class="center-service-panel">
        <custom-panel :title="title" :height="height" :hideMore="true" @moreClick="moreClickHandle">
            <template #content>
                <div class="service-list">
                    <div
                        class="service-item"
                        v-for="(item, index) in list"
                        :key="item.id + index"
                        @click="itemClickHandle(item)"
                    >
                        <div v-if="item.iconBase64 || item.iconUrl" class="service-icon dynamic-icon">
                            <img :src="item.iconBase64 || item.iconUrl" :alt="item.menuName || item.text" />
                        </div>
                        <div v-else :class="['service-icon', item.id]"></div>
                        <div class="service-name">{{ item.menuName }}</div>
                    </div>
                </div>
            </template>
        </custom-panel>
    </div>
</template>

<script>
import CustomPanel from '@/components/custom-panel.vue';
import { queryServiceMenus } from '@/common/api';

export default {
    props: {
        height: {
            type: Number
        }
    },

    components: {
        CustomPanel
    },

    data() {
        return {
            title: '中心服务',
            // list: [
            //     { id: 'online-entrust', name: '在线委托', path: '/test-service' },
            //     { id: 'training-system', name: '会培系统', path: 'https://www.ctqtc.com.cn/ctms/' },
            //     { id: 'control-sample-order', name: '控制样订购', path: '/sample/sample-order' },
            //     {
            //         id: 'ability-compare-system',
            //         name: '能力比对系统',
            //         path: 'http://www.ctqtc.com.cn/nlbd/main/web/login/index.jsp'
            //     },
            //     { id: 'satisfaction-survey', name: '满意度调查' },
            //     { id: 'process-query', name: '进度查询' },
            //     { id: 'report-query', name: '报告查询', path: '/query-service/report-query' },
            //     { id: 'cert-query', name: '证书查询' }
            // ]
            list: []
        };
    },

    methods: {
        moreClickHandle() {
            // console.log('more click');
        },

        async getServiceMenus() {
            try {
                const { data } = await queryServiceMenus('中心服务');
                if (Array.isArray(data)) {
                    this.list = data;
                }
            } catch (error) {
                console.error('获取中心服务菜单失败:', error);
            }
        },

        itemClickHandle(item) {
            const path = (item.route || item.path)?.trim();

            if (!path) {
                this.$message.warning('该服务暂未开通，敬请期待！');
                return;
            }

            if (/^https?:\/\//i.test(path)) {
                window.open(path, item.id);
            } else if (path.startsWith('/')) {
                this.$router.push(path);
            } else {
                this.$message.warning('该服务暂未开通，敬请期待！');
            }
        }
    },

    created() {
        this.getServiceMenus();
    }
};
</script>

<style lang="scss" scoped>
.center-service-panel {
    .service-list {
        display: flex;
        flex-flow: row wrap;
        justify-content: space-between;
        gap: 10px;

        .service-item {
            width: 128px;
            height: 114px;
            border-radius: 4px;
            border: 1px solid #b6c6eb;
            cursor: pointer;

            &:hover {
                background: #f0f4fb;
            }

            .service-icon {
                width: 44px;
                height: 44px;
                margin: 16px auto 6px;

                &.dynamic-icon img {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                }

                &.online-entrust {
                    background: url('../imgs/icon-online-entrust.svg') no-repeat center;
                }

                &.training-system {
                    background: url('../imgs/icon-training-system.svg') no-repeat center;
                }

                &.control-sample-order {
                    background: url('../imgs/icon-control-sample-order.svg') no-repeat center;
                }

                &.ability-compare-system {
                    background: url('../imgs/icon-ability-compare-system.svg') no-repeat center;
                }

                &.satisfaction-survey {
                    background: url('../imgs/icon-satisfaction-survey.svg') no-repeat center;
                }

                &.process-query {
                    background: url('../imgs/icon-process-query.svg') no-repeat center;
                }

                &.report-query {
                    background: url('../imgs/icon-report-query.svg') no-repeat center;
                }

                &.cert-query {
                    background: url('../imgs/icon-cert-query.svg') no-repeat center;
                }
            }

            .service-name {
                padding: 0 12px;
                font-size: 16px;
                color: #333333;
                text-align: center;
                line-height: 20px;
                font-weight: 600;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }
}
</style>
